import type { BetslipItem } from '@/stores/betslip'

// Draws are grouped only when the selection and stake are identical.
export function rebetLineKey(bet: BetslipItem): string {
  return JSON.stringify([
    String(bet.game_id), String(bet.market_id), String(bet.market_group_id),
    String(bet.outcome_id ?? ''), String(bet.game_market_id ?? ''),
    bet.specifier ?? '', bet.numbers, bet.stake, bet.betType ?? '',
    bet.numBets ?? 1, bet.picks ?? 0,
  ])
}

export function mergeRebetDraws(
  existing: BetslipItem['draws'],
  incoming: BetslipItem['draws']
): BetslipItem['draws'] {
  const byEvent = new Map(existing.map((draw) => [String(draw.event_id), draw]))
  incoming.forEach((draw) => byEvent.set(String(draw.event_id), draw))
  return [...byEvent.values()].sort((a, b) => Date.parse(a.draw_date) - Date.parse(b.draw_date))
}
